export default "__VITE_PUBLIC_ASSET__8e2a8419__"